module.exports = __webpack_public_path__ + "img/8.0313a888.jpg";